"use client";
import { makeGenericStorageContext } from "../context";
import { makeGenericStorage } from "./genericstorage";
/**
 * localStorage operations, define setter, getter and remover for this
 * storage implementation.
 */
const localStorageOperations = {
    getItem: (key) => {
        if (typeof window !== "undefined") {
            return window.localStorage?.getItem(key);
        }
        return null;
    },
    setItem: (key, value) => {
        if (typeof window !== "undefined") {
            window.localStorage?.setItem(key, value || "");
        }
    },
    removeItem: (key) => {
        if (typeof window !== "undefined") {
            window.localStorage?.removeItem(key);
        }
    },
};
const { useStorage, Provider } = makeGenericStorage("LocalStorage", localStorageOperations, makeGenericStorageContext);
/**
 * Return a localStorage store, to be used for interacting with localStorage.
 *
 * Usage:
 * ```
 * const localStorage = useLocalStorage();
 *
 * const myValue = localStorage.getItem("my-key");
 * ```
 *
 * @returns a localStorage store.
 * @public
 */
export const useLocalStorage = useStorage;
/**
 * LocalStorageProvider component.
 * This provides a LocalStorage context for your app. Note that directly using
 * this component is only needed if you are not using this via the gatsby plugin.
 *
 * Usage:
 * ```
 * function App = () => {
 *   // Use this provider to pass the
 *   // localStorage context to the tree below.
 *   // You can invoke `useLocalStorage` in any
 *   // of the components within.
 *   return (
 *     <LocalStorageProvider>
 *       <MyApp />
 *     </LocalStorageProvider>
 *   );
 * }
 * ```
 */
export const LocalStorageProvider = Provider;
//# sourceMappingURL=localstorage.js.map